import React from "react";
import { Row, Col, Card, Button, Typography, Image } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import "./Home.css";
import heroImage from "./images/cafe-hero.jpeg";
import interiorDay from "./images/cafe-interior-day.jpeg";
import interiorNight from "./images/cafe-interior-night.jpeg";

const { Title, Paragraph, Text } = Typography;

const Home = () => {
  return (
    <div className="cafe-page">
      <header className="cafe-header">
        <div className="cafe-logo">The Nursery Cafe & Bar</div>
        <nav className="cafe-nav">
          <a href="#about">About</a>
          <a href="#menu">Menu</a>
          <a href="#visit">Visit</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>

      <main>
        {/* Hero */}
<section className="hero">
  <div
    className="hero-bg"
    style={{ backgroundImage: `url(${heroImage})` }}
  />
  <div className="hero-overlay" />
  <div className="hero-content">
    <Text className="hero-kicker">The Nursery &nbsp; Cafe & Bar</Text>
    <Title level={1} className="hero-title">
      The Nursery 
      <br />
     Cafe & Bar
    </Title>
    <Paragraph className="hero-subtitle">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
      eiusmod tempor incididunt.
    </Paragraph>
    <Button
      type="primary"
      size="large"
      shape="round"
      className="hero-button"
      icon={<ArrowRightOutlined />}
    >
      Get Started
    </Button>
  </div>
</section>


        {/* Content section */}
        <section id="about" className="content-section">
          <Row gutter={[40, 40]} align="middle">
            <Col xs={24} md={12}>
              <div className="content-image-wrapper">
                <Image
                  src={interiorDay}
                  alt="Cafe interior"
                  className="content-image"
                  preview={true}
                />
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="content-text">
                <Title level={2}>Lorem ipsum dolor</Title>
                <Paragraph>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna
                  aliqua. Enim nunc faucibus a pellentesque sit amet porttitor
                  eget dolor.
                </Paragraph>
                <Paragraph>
                  Amet porttitor eget dolor morbi non arcu risus quis varius.
                  Nisi porta lorem mollis aliquam ut porttitor leo a diam
                  sollicitudin.
                </Paragraph>
              </div>
            </Col>
          </Row>
        </section>

        {/* Gallery / vibe section */}
        <section id="visit" className="gallery-section">
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Card
                hoverable
                className="gallery-card"
                cover={
                  <Image
                    src={interiorNight}
                    alt="Cafe at night"
                    className="gallery-image"
                    preview={true}
                  />
                }
              >
                <Title level={3} className="gallery-title">
                  Evenings at the café
                </Title>
                <Paragraph className="gallery-text">
                  Sit back under warm lights surrounded by greenery, crafted
                  drinks and a calm, cozy atmosphere.
                </Paragraph>
              </Card>
            </Col>

            <Col xs={24} md={12}>
              <Card
                hoverable
                className="gallery-card"
                cover={
                  <Image
                    src={interiorDay}
                    alt="Cafe in the day"
                    className="gallery-image"
                    preview={true}
                  />
                }
              >
                <Title level={3} className="gallery-title">
                  Bright daytime space
                </Title>
                <Paragraph className="gallery-text">
                  Natural light, minimalist decor and carefully curated music
                  make it perfect for work or slow brunch.
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </section>

      </main>

      <footer id="contact" className="cafe-footer">
        <div className="footer-left">
          <div className="footer-logo">CAFÉ</div>
          <p>123 Green Street, Singapore</p>
          <p>Open daily · 8:00 AM – 10:00 PM</p>
        </div>
        <div className="footer-right">
          <p>© {new Date().getFullYear()} Café. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
